import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Camera(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.349 2c.78 0 1.5.39 1.925 1.044l1.544 2.323h2.168a2.859 2.859 0 012.856 2.856v10.122a2.973 2.973 0 01-2.97 2.969H3.97A2.973 2.973 0 011 18.344V8.224a2.859 2.859 0 012.857-2.856h1.969l1.548-2.331A2.285 2.285 0 019.294 2h5.055zm0 2H9.294a.296.296 0 00-.25.135L7.36 6.672a1.543 1.543 0 01-1.292.695H3.857A.856.856 0 003 8.223v10.122a.97.97 0 00.969.969h15.903a.97.97 0 00.969-.97V8.224a.856.856 0 00-.856-.856h-2.411a1.54 1.54 0 01-1.297-.704l-1.675-2.521A.301.301 0 0014.349 4zM11.92 7.268a5.347 5.347 0 015.341 5.34 5.347 5.347 0 01-5.34 5.341 5.347 5.347 0 01-5.342-5.34 5.347 5.347 0 015.341-5.34zm0 2a3.345 3.345 0 00-3.34 3.34 3.345 3.345 0 003.34 3.341 3.345 3.345 0 003.341-3.34 3.345 3.345 0 00-3.34-3.34z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoCamera = React.memo(Camera);
export default MemoCamera;